/* eslint-disable no-unused-vars */
import db from "../../db/db";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../utils/API";
import { PricingUtils } from "../../utils/PricingUtils";
import { PrintUtils } from "../../utils/PrintUtils";
import { SyncUtils } from "../../utils/SyncUtils";
import DuplicateInvoicePrompt from "./DuplicateInvoicePrompt";
import PDialog from "../../components/pos/PDialog";
import { CircularProgress, Grid } from "@mui/material";
import { Store } from "../../utils/Store";

export const SalesDao = (props) => {
  const { t } = useTranslation();
  const translate = t;

  const [invoicePrefix, setInvoicePrefix] = useState("");
  const [invoice, setInvoice] = useState(null);
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");

  const [showDuplicateInvoicePrompt, setShowDuplicateInvoicePrompt] =
    useState(false);

  props.biRef.saleDao = {
    onSave: onSave,
    print: print,
  };

  useEffect(() => {
    if (
      localStorage.getItem(
        (props.context.appMode === "mobile" ? "m_failedOp1" : "w_failedOp1") +
          (props.holdMode ? "_hold" : "")
      )
    ) {
      saveSale(
        JSON.parse(
          localStorage.getItem(
            (props.context.appMode === "mobile"
              ? "m_failedOp1"
              : "w_failedOp1") + (props.holdMode ? "_hold" : "")
          )
        ),
        true,
        "recovery"
      );
    }
    initInvoice();
  }, []);

  function getTargetTable() {
    if (props.saleType === "SALE") {
      return "sale" + (props.holdMode ? "_hold" : "");
    }
    if (props.saleType === "SALE_RETURN") {
      return "sale_return" + (props.holdMode ? "_hold" : "");
    }
    if (props.saleType === "SERVICE") {
      return "service" + (props.holdMode ? "_hold" : "");
    }
    if (props.saleType === "SALE_ORDER") {
      return "sale_order" + (props.holdMode ? "_hold" : "");
    }
    if (props.saleType === "R_SALE") {
      if (props.currentMenu === "dineIn") return "r_sale_dineIn";
      if (props.currentMenu === "takeAway") return "r_sale_take_away";
      if (props.currentMenu === "delivery") return "r_sale_delivery";
      if (props.currentMenu === "online") return "r_sale_online";
    }
    return "";
  }

  function getPrintFormat(status) {
    if (props.saleType === "SALE") {
      return props.holdMode
        ? "HOLD_SALE_PRINT_FORMAT"
        : "SALE_RECEIPT_PRINT_FORMAT";
    }
    if (props.saleType === "SALE_RETURN") {
      return (
        "SALE_RETURN_RECEIPT_PRINT_FORMAT" + (props.holdMode ? "_HOLD" : "")
      );
    }
    if (props.saleType === "SERVICE") {
      return "SERVICE_RECEIPT_PRINT_FORMAT" + (props.holdMode ? "_HOLD" : "");
    }
    if (props.saleType === "SALE_ORDER") {
      return "SALE_ORDER_PRINT_FORMAT" + (props.holdMode ? "_HOLD" : "");
    }
    if (props.saleType === "R_SALE") {
      if (props.currentMenu === "dineIn") {
        if (status === "BILL CREATED") {
          return "R_POS_DINE_IN_PREVIEW_INVOICE_FORMAT";
        } else return "";
      }
      if (props.currentMenu === "takeAway")
        return "R_POS_TAKEAWAY_TOKEN_FORMAT";
      if (props.currentMenu === "delivery") {
        if (status === "BILL CREATED") {
          return "R_POS_DELIVERY_PREVIEW_INVOICE_FORMAT";
        } else return "";
      }
      if (props.currentMenu === "online") return "";
    }
    return "";
  }

  async function initInvoice() {
    let storeAdminVal = await db.setting
      .where("sKey")
      .equals("store_admin")
      .toArray();

    let storeAdminSetting = JSON.parse(storeAdminVal[0].sValue);
    let terminalInvoicePrefix = "";
    if (storeAdminSetting.terminalWiseInvoicing) {
      terminalInvoicePrefix = props.terminalBean.invoicePrefix
        ? props.terminalBean.invoicePrefix
        : props.terminalBean.terminalKey;
    }
    if (props.saleType == "SALE") {
      setInvoicePrefix(
        (props.holdMode ? "H" : "") +
          storeAdminSetting.invoicePrefix +
          terminalInvoicePrefix
      );
    }
    if (props.saleType == "SALE_RETURN") {
      setInvoicePrefix(
        (props.holdMode ? "H" : "") +
          storeAdminSetting.saleReturnPrefix +
          terminalInvoicePrefix
      );
    }
    if (props.saleType == "SERVICE") {
      setInvoicePrefix(
        (props.holdMode ? "H" : "") +
          storeAdminSetting.servicePrefix +
          terminalInvoicePrefix
      );
    }
    if (props.saleType == "SALE_ORDER") {
      setInvoicePrefix(
        (props.holdMode ? "H" : "") +
          storeAdminSetting.saleOrderPrefix +
          terminalInvoicePrefix
      );
    }
  }

  function enablePrint(saleSetting) {
    if (props.saleType === "R_SALE") {
      if (props.currentMenu === "takeAway" && saleSetting.enableTakeAwayToken) {
        return true;
      }
      if (props.currentMenu === "dineIn") {
        return true;
      }
      if (props.currentMenu === "delivery") {
        return true;
      }
      return false;
    }
    return true;
  }

  async function onSave(flag, isHold, ensureNewuuid, status, buttonIndex) {
    console.log("Saving");
    let printFormat = getPrintFormat(status);
    let payload = await props.createPayload(isHold, ensureNewuuid, status);
    payload.printFormat = printFormat;
    localStorage.removeItem(props.saleType + "_running_sale");
    console.log("Sale data: " + JSON.stringify(payload));
    try {
      //let { data } = await API.post("/api/v1/sale", payload);
      let targetTable = getTargetTable();

      let storeAdminVal = await db.setting
        .where("sKey")
        .equals("store_admin")
        .toArray();
      let storeAdminSetting = JSON.parse(storeAdminVal[0].sValue);

      //console.log try to save online
      if (
        !storeAdminSetting.offlineMode ||
        !storeAdminSetting.terminalWiseInvoicing
      ) {
        let savePayload = {
          saleType: props.saleType,
          targetTable: targetTable,
          payload: payload,
          flag: flag,
          printFormat: printFormat,
          holdId: props.holdId,
        };
        payload = await saveSale(savePayload, flag, "save");
      } else {
        if (props.uuid || props.editMode) {
          db.table(targetTable).put(payload);
          SyncUtils.createSyncMeta("UPDATE", payload.id, targetTable);
        } else {
          payload["invoicePrefix"] = invoicePrefix;
          payload["seqInvoice"] = props.nextInvoiceNo;
          payload["invoiceNo"] = invoicePrefix + props.nextInvoiceNo;

          db.table(targetTable).add(payload);

          props.setNextInvoiceNo(props.nextInvoiceNo + 1);
          SyncUtils.createSyncMeta("CREATE", payload.id, targetTable);
        }

        if (props.customerBean) {
          payload.customerBean = props.customerBean;
        }
        let terminalConfig = JSON.parse(
          localStorage.getItem(
            props.context.appMode === "mobile" ? "m_terminal" : "w_terminal"
          )
        );
        payload.terminalBean = terminalConfig;
        console.log("buttonindex_saleDao", buttonIndex);
        await print(
          payload,
          flag,
          printFormat,
          "save",
          props.holdId,
          null,
          null,
          buttonIndex
        );
      }
      await postSaveAction("save", payload);
    } catch (err) {
      console.log(err);
      props.setAlert({
        show: true,
        title: "Error",
        message: translate("Not able to save "),
      });
    }
  }

  async function saveSale(payload, printAfterSave, saveMode) {
    showProgress(true, "Saving ");
    let flag = true;
    let saveResult = null;
    while (flag) {
      try {
        saveResult = await API.post(
          "/api/v1/" + payload.targetTable,
          payload.payload
        );
        if (props.context.appType === "R_POS") {
          props.refreshQueue(props.currentMenu);
        }
        if (props.setSelectedQueue) {
          props.setSelectedQueue({});
        }
        if (props.setParentSaleBean) {
          props.setParentSaleBean(null);
        }
        if (props.setworkflowStatus) {
          props.setworkflowStatus("NEW");
        }
        if (props.setTableInfo) {
          props.setTableInfo([]);
        }
        if (props.setSalesManInfo) {
          props.setSalesManInfo({});
        }
        localStorage.removeItem(
          (props.context.appMode === "mobile" ? "m_failedOp1" : "w_failedOp1") +
            (props.holdMode ? "_hold" : "")
        );

        showProgress(false, "Saving ");
        break;
      } catch (err) {
        console.log(err);
        localStorage.setItem(
          (props.context.appMode === "mobile" ? "m_failedOp1" : "w_failedOp1") +
            (props.holdMode ? "_hold" : ""),
          JSON.stringify(payload)
        );
        await sleep(5000);
      }
    }

    if (printAfterSave) {
      await print(
        saveResult.data,
        payload.flag,
        payload.printFormat,
        saveMode,
        payload.holdId,
        payload.saleType
      );
    }

    if (payload.holdId) {
      props.deleteHoldItem(payload.holdId);
      props.setHoldId("");
    }

    return saveResult.data;
  }

  async function postSaveAction(saveMode, payload) {
    props.setPrivileges(props.context.privileges);
    props.setCurrentUser(
      Store.parseJwt(
        Store.get(
          props.context.appMode === "mobile"
            ? "m_refreshToken"
            : "w_refreshToken"
        )
      ).sub
    );

    if (saveMode == "save") {
      let val = await db.setting.where("sKey").equals("sale").toArray();
      let saleSettings = JSON.parse(val[0].sValue);
      let autolosePayment =
        saleSettings.autoClosePayment != null &&
        saleSettings.autoClosePayment != undefined
          ? saleSettings.autoClosePayment
          : true;
      if (
        props.saleType === "SALE" ||
        props.saleType === "SALE_RETURN" ||
        props.saleType === "SALE_ORDER" ||
        props.saleType === "SERVICE" ||
        props.saleType === "R_SALE"
      ) {
        if (
          props.setLastBill &&
          saleSettings.showLastBillSummary &&
          props.saleType != "SERVICE" &&
          props.saleType != "R_SALE"
        ) {
          props.setLastBill(getBillSummary(payload));
          props.setShowLastSaleSummary(true);
        }

        props.setSaleData([]);
        props.setRawSale([]);
        props.setCustomerBean(null);
        props.setCustomerBeanForHold(null);
        props.setTradingDate(null);
        props.setSalesManInfo({});
        props.setTradingScreenPaymentModeSelect(null);

        props.resetCustomFields();
        if (props.setParentSaleBean) {
          props.setParentSaleBean(null);
          props.setParentType(null);
        }
        if (autolosePayment) {
          props.setCurrentScreen("sale");
          if (props.setShowPaymentScreen) props.setShowPaymentScreen(false);
        } else {
          if (props.paymentEvent) props.paymentEvent("settled");
        }
      }
      if (props.clearServiceDetails) {
        props.clearServiceDetails();
      }
      if (props.setUuid) {
        props.setUuid(null);
      }
      if (props.setEditMode) {
        props.setEditMode(false);
      }
      if (props.setSrNumber) {
        props.setSrNumber("NEW");
      }
      if (props.saleType === "SERVICE") {
        props.setSaleData([]);
        props.setRawSale([]);
        props.setRawSale([]);
        props.clearServiceData();

        props.setUuid(null);
        props.setInvoiceNumber("NEW");
      }
      if (props.holdMode) {
        props.setShowHoldWindow(false);
      }
      props.setHoldNote(null);
    }
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function print(
    payload,
    flag,
    printFormat,
    saveMode,
    holdId,
    saleType,
    voidPrint,
    buttonIndex
  ) {
    console.log("buttonindex_saleDao_2", buttonIndex);
    try {
      if (printFormat === "") return;
      let val = await db.setting.where("sKey").equals("sale").toArray();
      let saleSettings = JSON.parse(val[0].sValue);

      if (flag === "Print") {
        let jwt = parseJwt(
          localStorage.getItem(
            props.context.appMode === "mobile"
              ? "m_refreshToken"
              : "w_refreshToken"
          )
        );
        payload.updatedBy = jwt.sub;

        PrintUtils.augmentSaleDetailsForPrint(
          payload,
          props.context.store.currencyDecimal,
          props.saleType
        );

        console.log("payload", payload);

        let showPrintConfirmation =
          saleSettings.showPrintConfirmation != null &&
          saleSettings.showPrintConfirmation != undefined
            ? saleSettings.showPrintConfirmation
            : false;

        if (showPrintConfirmation) {
          showProgress(true, "Printing");
        }
        if (enablePrint(saleSettings)) {
          await PrintUtils.openDrawer(
            props.terminalBean,
            props.setAlert,
            translate
          );
          await PrintUtils.printReceipt(
            props.terminalBean,
            printFormat,
            payload,
            props.setAlert,
            true,
            translate,
            showPrintConfirmation,
            false,
            false,
            props.pdfViewer,
            buttonIndex
          );
        }

        if (showPrintConfirmation) {
          showProgress(false, "Printing");
        }

        if (!voidPrint) setInvoice(payload);

        if (saleSettings.duplicateInvoice) {
          setShowDuplicateInvoicePrompt(true);
        }
      }
    } catch (err) {
      console.log(err);
      props.setAlert({
        show: true,
        title: "Error",
        message: translate("Not Able to Save"),
      });
    }
  }

  function getBillSummary(saleBean) {
    let total = saleBean.totalAmount;
    let tendered = 0;
    let balance = 0;

    let dat = [];

    for (let d of saleBean.salePaymentBeanList) {
      if (d.code != "DISCOUNT") {
        dat.push(d);
        if (d.isFx) {
          let tenderedInBaseCurrency =
            parseFloat(d.fxReceived) * parseFloat(d.conversionRate);
          tendered = tendered + tenderedInBaseCurrency;
          if (d.balanceCurrencyType === "BASE") {
            balance = balance + parseFloat(d.balanceInBaseCurrency);
          } else {
            let balanceInBaseCurrency =
              parseFloat(d.balanceInSourceCurrency) *
              parseFloat(d.conversionRate);
            balance = balance + balanceInBaseCurrency;
          }
        } else {
          tendered = tendered + parseFloat(d.tendered);
          balance = balance + parseFloat(d.balance);
        }
      }
    }
    return { paycodes: dat, total: total };
    /*return {
      amount: total,
      tendered: PricingUtils.formattedNumber(
        tendered,
        props.context.store.currencyDecimal
      ),
      balance: PricingUtils.formattedNumber(
        balance,
        props.context.store.currencyDecimal
      ),
    };*/
  }

  function parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    console.log(jsonPayload);
    return JSON.parse(jsonPayload);
  }

  async function onDuplicateInvoice() {
    invoice.duplicate = true;
    let printFormat = getPrintFormat();

    PrintUtils.printReceipt(
      props.terminalBean,
      printFormat,
      invoice,
      props.setAlert,
      true,
      translate,
      false,
      false,
      null,
      props.pdfViewer
    );
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  return (
    <div>
      {showDuplicateInvoicePrompt && (
        <DuplicateInvoicePrompt
          biRef={props.biRef}
          context={props.context}
          showMessage={props.showMessage}
          setOpenWindow={setShowDuplicateInvoicePrompt}
          onDuplicateInvoice={onDuplicateInvoice}
        ></DuplicateInvoicePrompt>
      )}
      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          maxWidth={"md"}
          fullWidth={false}
          open={true}
          borderLess={true}
        ></PDialog>
      )}
    </div>
  );
};
export default SalesDao;
